'use client';
import React from 'react';
import Hero from './hero';
import Content from './content';
import CtaBanner from './ctaBanner';
import Content2 from '@/app/blog/business-travellers-car-service-dallas/content2';
import CtaBanner2 from './ctaBanner2';
import CtaBanner3 from './content3';
import MainCta from './mainCta';
import Backforward from '../backforward';
import Tawko2 from '../../componenets/tawko2';
import Navbar from '@/app/componenets/Navbar';
import Footer from '@/app/componenets/Footer';
// import Sticky from '../business-travellers-car-service-dallas/sticky'
function page() {
  return (
    <>
      <title>Why Business Travelers Choose Black Car Services in Dallas?</title>
      <meta
        name="description"
        content="Explore why Dallas business travelers prefer black car services for professionalism, comfort, and safety. Book your tour with Prestige Ride today."
      />

      {/* <!-- Facebook Meta Tags --> */}
      <meta property="og:url" content="https://www.prestigeride.com" />
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Why Business Travelers Choose Black Car Services in Dallas?"
      />
      <meta
        property="og:description"
        content="Explore why Dallas business travelers prefer black car services for professionalism, comfort, and safety. Book your tour with Prestige Ride today."
      />
      <meta
        property="og:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
      />

      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content="prestigeride.com" />
      <meta property="twitter:url" content="https://www.prestigeride.com" />
      <meta
        name="twitter:title"
        content="Why Business Travelers Choose Black Car Services in Dallas?"
      />
      <meta
        name="twitter:description"
        content="Explore why Dallas business travelers prefer black car services for professionalism, comfort, and safety. Book your tour with Prestige Ride today"
      />
      <meta
        name="twitter:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
      />
      <meta name="robots" content="index, follow" />
      <link
        rel="canonical"
        href="https://www.prestigeride.com/blog/business-travellers-car-service-dallas"
      />

      <Navbar />
      <Hero />
      {/* <Sticky/> */}
      <div className="mx-auto max-w-5xl px-4 lg:px-6 text-[#2B3252] ">
        <Content />
        <CtaBanner />
        <Content2 />
      </div>
      <MainCta />
      <div className="mx-auto max-w-5xl px-4 lg:px-6 text-[#2B3252] mb-5">
        <CtaBanner3 />
        <CtaBanner2 />
        <Backforward />
      </div>
      <Tawko2 />
      <Footer />
    </>
  );
}

export default page;
